import {createStore} from 'vuex'

export default createStore({
    state: {
        user: JSON.parse(sessionStorage.getItem('user') || 'null'),
        isLoading: false,
        msisdn: sessionStorage.getItem('msisdn') || undefined,
        brandConfig: JSON.parse(sessionStorage.getItem('brandConfig') || 'null'),
        productId: sessionStorage.getItem('productId') || undefined
    },
    mutations: {
        setUser(state, user) {
            state.user = user
            sessionStorage.setItem('user', JSON.stringify(user))
        },
        setIsLoading(state, isLoading) {
            state.isLoading = isLoading
        },
        setMsisdn(state, msisdn) {
            state.msisdn = msisdn
            sessionStorage.setItem('msisdn', msisdn)
        },
        setBrandConfig(state, brandConfig) {
            state.brandConfig = brandConfig
            sessionStorage.setItem('brandConfig', JSON.stringify(brandConfig))
        },
        setProductId(state, productId) {
            state.productId = productId
            sessionStorage.setItem('productId', productId)
        }
    },
    actions: {},
    modules: {}
})
